const warning = {
  main: "#FFC70C",
  light: "#FFC70C",
  dark: "#FFC70C",
};

export { warning };
